class HeaderSidebarDropdown extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.content = this.querySelector('.header-sidebar__nested-linklist');
    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
    
    // Close sibling dropdowns at the same level
    this.closeSiblingDropdowns();
    
    // Toggle current dropdown
    this.button.setAttribute('aria-expanded', !isExpanded);
    
    if (!isExpanded) {
      // Opening
      this.content.hidden = false;
      // Get natural height
      const height = this.content.scrollHeight;
      this.content.style.maxHeight = '0px';
      // Force reflow
      this.content.offsetHeight;
      this.content.style.maxHeight = height + 'px';
    } else {
      // Closing
      this.content.style.maxHeight = '0px';
      this.content.addEventListener('transitionend', () => {
        if (this.button.getAttribute('aria-expanded') === 'false') {
          this.content.hidden = true;
          this.content.style.maxHeight = '';
        }
      }, { once: true });
    }
  }

  closeSiblingDropdowns() {
    // Find sibling dropdowns at the same level
    const parent = this.parentElement.closest('.header-sidebar__nested-linklist') || this.parentElement.closest('.header-sidebar__linklist');
    const siblings = parent.querySelectorAll(':scope > li > accordion-disclosure');
    siblings.forEach(dropdown => {
      if (dropdown !== this) {
        const button = dropdown.querySelector('button');
        const content = dropdown.querySelector('.header-sidebar__nested-linklist');
        if (button && content) {
          button.setAttribute('aria-expanded', 'false');
          content.style.maxHeight = '0px';
        }
      }
    });
  }
}

if (!customElements.get('accordion-disclosure')) {
  customElements.define('accordion-disclosure', HeaderSidebarDropdown);
}

  document.addEventListener('DOMContentLoaded', () => {
    const unitSwitch = document.getElementById('unitSwitch');
    const sizeChart = document.getElementById('sizeChart');

    if (!unitSwitch || !sizeChart) {
        return; // Exit silently if elements don't exist
    }

    unitSwitch.addEventListener('change', () => {
        const cmRows = document.querySelectorAll('.size-row.cm');
        const inRows = document.querySelectorAll('.size-row.in');
        const displayType = unitSwitch.checked ? 'table-row' : 'none';
        const hideType = unitSwitch.checked ? 'none' : 'table-row';

        cmRows.forEach(row => row.style.display = hideType);
        inRows.forEach(row => row.style.display = displayType);
    });
});
// Function to add 'fixed-column' class to the first column of the table
function addFixedColumnClass() {
  const tables = document.querySelectorAll('.responsive-table');
  
  tables.forEach((table) => {
    const rows = table.querySelectorAll('tr');
    
    rows.forEach((row) => {
      const firstCell = row.querySelector('td:first-child');
      
      if (firstCell) {
        firstCell.classList.add('fixed-column');
      }
    });
  });
}
